import { ReactNode, useState } from 'react'
import DayTile from './DayTile'
import { getSessionsToDisplay, shouldRenderDayTiles } from '@/utils/components/EventDayTiles.utils'
import { PartialModalState } from '@/types/ModalProvider.types'

const EventDayTiles = ({
  isRecurringEvent,
  eventTickets,
  eventDays,
  incomingDate,
  updateModalState,
}: {
  isRecurringEvent: boolean
  eventTickets: Transformed.EventTicketsAndAddonsWithTimeslots[]
  eventDays: Transformed.Timeslot[]
  incomingDate: Nullable<string>
  updateModalState: (nextState: PartialModalState) => void
}): ReactNode => {
  // store the current display range to maintain stability
  const [currentDisplay, setCurrentDisplay] = useState<Nullable<{
    startIndex: number
    endIndex: number
    sessions: Transformed.Timeslot[]
  }>>(null)

  if (!shouldRenderDayTiles(isRecurringEvent, eventTickets, eventDays)) {
    if (currentDisplay !== null) {
      setCurrentDisplay(null)
    }
    return null
  }

  const selectedSessionId = eventTickets[0].timeslot.id

  // Check if the selected session is already in the current display
  const isSelectedInCurrentDisplay = currentDisplay?.sessions.some(
    (session) => session.id === selectedSessionId,
  )

  let dayTilesToDisplay = currentDisplay?.sessions || []

  if (!isSelectedInCurrentDisplay) {
    const selectedIndex = eventDays.findIndex((el) => el.id === selectedSessionId)
    // calculate the new sessions to display
    const {
      startIndex,
      endIndex,
      sessions: uniqueSessions,
    } = getSessionsToDisplay(selectedIndex, eventDays, eventTickets[0].timeslot)

    // Update the state with the new display range
    setCurrentDisplay({ startIndex, endIndex, sessions: uniqueSessions })
    dayTilesToDisplay = uniqueSessions
  }

  if (dayTilesToDisplay.length === 0) {
    return null
  }

  return (
    <>
      {dayTilesToDisplay.map((session) => (
        <DayTile key={session.id} session={session} incomingDate={incomingDate} updateModalState={updateModalState} />
      ))}
    </>
  )
}

export default EventDayTiles
